<template>
  <div>
    <table class="debug-table" v-if="restaurants?.length">
      <tbody>
        <tr>
          <th class="w-2">#</th>
          <th>ID</th>
          <th>Name</th>
          <th>Rank</th>
          <th>Address</th>
          <th>City</th>
          <th>Tags</th>
        </tr>
        <tr v-for="restaurant, rKey in restaurants">
          <td v-html="rKey+1" />
          <td v-html="restaurant.id" />
          <td>
            <NuxtLink :to="{ name: 'restaurants-slug', params: { slug: restaurant.slug }}">
              {{ restaurant.name }}
            </NuxtLink>
          </td>
          <td v-html="restaurant.rank" />
          <td v-html="restaurant.address.replace(',', ' ')" />
          <td v-html="restaurant.city" />
          <td v-html="restaurant.tags.map(tag => tag.label)?.join(', ')" />
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script async setup>
const props = defineProps({
  restaurants: {
    type: Array,
    default: () => []
  }
})
</script>